<template>
  <el-row class="m-0 width-100-p mt-3">
    <el-col class="d-flex align-item-center px-2" :span="24">
      <div
        :class="$vuetify.display.width < 1500 ? 'row m-0 width-100-p' : 'row m-0 width-100-p px-2'">
        <div
          class="row m-0 py-3 width-100-p bg-me-primary border-color-light rounded-4"
        >
          <el-col class="mb-2 px-0" :span="24">
            <div class="row m-0" :span="24">
              <el-row :gutter="$vuetify.display.width > 1500 ? 20 : 10">
              <!-- table tabs radio group -->
              <el-col :span="24">
                  <h5 class="text-white mt-3 ml-1">Select Delete Option </h5>
              </el-col>
              <el-col
              :span="$vuetify.display.width > 1500 ? 8 : 22"
              :class="'x-start order-1 mb-10'"
              >
                <el-radio-group
                  v-model="chargerFilter"
                  @change="selectChargerFilter"
                  text-color="#ffff"
                  fill="#234B49"
                  :class="$vuetify.display.width < 800 ? 'width-100-p' : ''"
                  :style="$vuetify.display.width < 800 ? 'display: flex;' : 'display: flex; gap:0px; white-space: nowrap;'"
                >
                  <el-radio-button
                    class="start-period all-group-by text-center"
                    label="1"
                    :style="$vuetify.display.width < 800 ? 'flex: 1; width: 20%;' : 'max-width: 80px;'"
                  >
                    All
                  </el-radio-button>
                  <el-radio-button
                    class="site-group-by text-center"
                    label="2"
                    :style="$vuetify.display.width < 800 ? 'flex: 1; width: 20%;' : 'max-width: 120px;'"
                  >
                    {{ $vuetify.display.width < 805 ? 'Site' : 'Charging Site' }}
                  </el-radio-button>
                  <el-radio-button
                    class="charger-group-by text-center"
                    label="3"
                    :style="$vuetify.display.width < 800 ? 'flex: 1; width: 20%;' : 'max-width: 100px;'"
                  >
                    Chargers
                  </el-radio-button>
                  <el-radio-button
                    class="port-group-by text-center end-period"
                    label="4"
                    :style="$vuetify.display.width < 800 ? 'flex: 1; width: 20%;' : 'max-width: 90px;'"
                  >
                    Ports
                  </el-radio-button>
                </el-radio-group>
              </el-col>

             <!--  search input -->
             <!-- <el-col
                :span="$vuetify.display.width > 1500 ? 15 : 24"
                :class="$vuetify.display.width > 1500 ? 'x-start order-2 mb-10 pr-20' : 'x-start order-3 mb-10'"
              >
                  <el-input
                    size="large"
                    v-model="search"
                    :placeholder=" (convertLabel(filter.state) == '' || convertLabel(filter.state) == 'all' ? '' : 'State: ' + convertShorterLabel(convertLabel(filter.state), 7, 8) + ' &#x7c; ' ) + 'Search by: ' +  (convertLabel(selectedSearchBy) == ''? ' ' : convertLabel(selectedSearchBy)) "
                    :prefix-icon="Search"
                    class="mixedSearchBar"
                    id="mixedSearchBar-input"
                    clearable
                    @clear="handleRefresh"
                  >
                    <template #prepend>

                     
                      <el-tooltip
                        effect="light"
                        placement="top"
                        show-after="500"
                        hide-after="300"
                        >
                        <template #content > 
                            <span :style="{fontSize: '12px', textAlign: 'left'}"> {{ "Select Search by" }} </span>
                        </template>

                        <el-select
                          v-model="selectedSearchBy"
                          placeholder="Select"
                          style="min-width: 117px; height: 40px;"
                          @change="handleSelectSearchBy"
                          class="mixedSearchBar-select"
                        >
                          <template #label>
                            <span>Search by: </span>
                            <span style="font-weight: bold">{{ convertLabel(selectedSearchBy) }}</span>
                          </template>
                          <el-option
                            v-for="(item, index) in search_by_dropdown[selectedTableTab]"
                            :key="index"
                            :label="convertLabel(item)"
                            :value="item"
                          />
                        </el-select>
                      </el-tooltip>
                    </template>
                    
                    <template #append>
                  
                      <el-button
                          @click.stop="handleRefresh"
                          class="newSearchButtonClass"
                        >
                        <svg v-if="$vuetify.display.width > 800" class="width-115 height-40">
                            <use
                              href="@/assets/svg/newSvgIcon.svg#newSearchButtonIcon"
                            ></use>
                          </svg>
                          <svg v-else class="width-59 height-40" >
                            <use
                              href="@/assets/svg/newSvgIcon.svg#newSearchButtonIcon-small"
                            ></use>
                          </svg>
                      </el-button>
                    </template>
                  </el-input>
              </el-col> -->
              </el-row>
            </div>
          </el-col>

          <!-- four tables -->
          <el-col :span="24">
            <div
              class="ma-0"
              v-loading="loading"
              :element-loading-spinner="svg"
              element-loading-svg-view-box="-10, -10, 50, 50"
              element-loading-background="rgba(122, 122, 122, 0.8)"
            >
              <!-- All List -->
              <div class="custom-table-design" v-if="chargerFilter == 1">
                <el-table
                  :data="siteDataList"
                  stripe
                  :fit="true"
                  height="300"
                  class="my-2 data-table"
                  scrollbar-always-on: false
                >
                  <el-table-column
                    :label="'Created At'"
                    :prop="'created_at'"
                    :width="$vuetify.display.width <= 750 ? 250 : ''"
                    sortable
                    v-if="
                      $store.state.auth.user != null &&
                      $store.state.auth.user.is_admin
                    "
                  >
                    <template #default="scope">
                      {{ scope.row.created_at.replace('T', ' ') }}
                    </template>
                </el-table-column>
                  <el-table-column
                    :label="'Number of Sites'"
                    :prop="'num_site'"
                    :width="$vuetify.display.width <= 750 ? 150 : ''"
                    sortable
                  />
                  <el-table-column
                    v-if="$vuetify.display.width < 750"
                    :label="'Operations'"
                    :prop="'operations'"
                    align="center"
                    width="150"
                  >
                    <template #default="scope">
                      <el-tooltip placement="top" effect="light">
                        <template #content>
                          Bulk delete charging sites, chargers, and ports
                          <br>
                          Click button to add customer and created at for bulk delete
                        </template>
                        <el-button
                            v-if="
                              $store.state.auth.user != null &&
                              !$store.state.auth.user.is_auditor
                            "
                          @click.stop="CopyCreateAt(scope.row.created_at, scope.row.customer_id)"
                          size="small"
                          class="height-25 rounded-2 m-0 ml-2"
                          color="#DDF0AC"
                          style="width: 25px; height: 25px; padding: 0px; align-items: center;"
                        >
                            <svg style="width: 24px; height: 24px;">
                                <use href="@/assets/svg/newSvgIcon.svg#tableOperationDelete"></use>
                            </svg>
                        </el-button>
                      </el-tooltip>
                    </template>
                  </el-table-column>
                  <el-table-column
                    v-else
                    fixed="right"
                    :label="'Operations'"
                    :prop="'operations'"
                    align="center"
                    width="250"
                  >
                    <template #default="scope">
                      <el-tooltip placement="top" effect="light">
                                  <template #content>
                                    Bulk delete charging sites, chargers, and ports
                                    <br>
                                    Click button to add customer and created at for bulk delete
                                  </template>
                                  <el-button
                                      v-if="
                                        $store.state.auth.user != null &&
                                        !$store.state.auth.user.is_auditor
                                      "
                                    @click.stop="CopyCreateAt(scope.row.created_at, scope.row.customer_id)"
                                    size="small"
                                    class="height-25 rounded-2 m-0 ml-2"
                                    color="#DDF0AC"
                                    style="width: 25px; height: 25px; padding: 0px; align-items: center;"
                                  >
                                      <svg style="width: 24px; height: 24px;">
                                          <use href="@/assets/svg/newSvgIcon.svg#tableOperationDelete"></use>
                                      </svg>
                                  </el-button>
                      </el-tooltip>
                    </template>
                  </el-table-column>
                </el-table>
              </div>

                <!-- Charging Site -->
                <div class="custom-table-design" v-else-if="chargerFilter == 2">
                <el-table
                  stripe
                  :data="siteDataList"
                  :fit="true"
                  height="300"
                  class="my-2 data-table"
                  scrollbar-always-on: false
                >
                  <el-table-column
                    :label="'Created At'"
                    :prop="'created_at'"
                    :width="$vuetify.display.width <= 750 ? 250 : ''"
                    sortable
                    v-if="
                      $store.state.auth.user != null &&
                      $store.state.auth.user.is_admin
                    "
                  >
                    <template #default="scope">
                      {{ scope.row.created_at.replace('T', ' ') }}
                    </template>
                  </el-table-column>
                  <el-table-column
                    :label="'Number of Sites'"
                    :prop="'num_site'"
                    :width="$vuetify.display.width <= 750 ? 150 : ''"
                    sortable
                  />
                  <el-table-column
          v-if="$vuetify.display.width < 750"
          :label="'Operations'"
          :prop="'operations'"
          align="center"
          width="150"
        >
          <template #default="scope">
                      <el-tooltip placement="top" effect="light">
                        <template #content>
                          Bulk delete charging sites, chargers, and ports
                          <br>
                          Click button to add customer and created at for bulk delete
                        </template>
                        <el-button
                            v-if="
                              $store.state.auth.user != null &&
                              !$store.state.auth.user.is_auditor
                            "
                          @click.stop="CopyCreateAt(scope.row.created_at, scope.row.customer_id)"
                          size="small"
                          class="height-25 rounded-2 m-0 ml-2"
                          color="#DDF0AC"
                          style="width: 25px; height: 25px; padding: 0px; align-items: center;"
                        >
                            <svg style="width: 24px; height: 24px;">
                                <use href="@/assets/svg/newSvgIcon.svg#tableOperationDelete"></use>
                            </svg>
                        </el-button>
                      </el-tooltip>
                      </template>
                    </el-table-column>
                    <el-table-column
          v-else
          fixed="right"
          :label="'Operations'"
          :prop="'operations'"
          align="center"
          width="250"
        >
          <template #default="scope">
                      <el-tooltip placement="top" effect="light">
                        <template #content>
                          Bulk delete charging sites, chargers, and ports
                          <br>
                          Click button to add customer and created at for bulk delete
                        </template>
                        <el-button
                            v-if="
                              $store.state.auth.user != null &&
                              !$store.state.auth.user.is_auditor
                            "
                          @click.stop="CopyCreateAt(scope.row.created_at, scope.row.customer_id)"
                          size="small"
                          class="height-25 rounded-2 m-0 ml-2"
                          color="#DDF0AC"
                          style="width: 25px; height: 25px; padding: 0px; align-items: center;"
                        >
                            <svg style="width: 24px; height: 24px;">
                                <use href="@/assets/svg/newSvgIcon.svg#tableOperationDelete"></use>
                            </svg>
                        </el-button>
                      </el-tooltip>

          </template>
        </el-table-column>
                </el-table>
                </div>

                <!-- Chargers -->
                <div class="custom-table-design"  v-else-if="chargerFilter == 3">
                <el-table
                  stripe
                  :data="chargerDataList"
                  :fit="true"
                  height="300"
                  class="my-2 data-table"
                  scrollbar-always-on: false
                >
                  <el-table-column
                    :label="'Created At'"
                    :prop="'created_at'"
                    :width="$vuetify.display.width <= 750 ? 250 : ''"
                    sortable
                    v-if="
                      $store.state.auth.user != null &&
                      $store.state.auth.user.is_admin
                    "
                  >
                    <template #default="scope">
                      {{ scope.row.created_at.replace('T', ' ') }}
                    </template>
                  </el-table-column>
                  <el-table-column
                    :label="'Number of Chargers'"
                    :prop="'num_charger'"
                    :width="$vuetify.display.width <= 750 ? 180 : ''"
                    sortable
                  />
                  <el-table-column
          v-if="$vuetify.display.width < 750"
          :label="'Operations'"
          :prop="'operations'"
          align="center"
          width="150"
        >
          <template #default="scope">
                      <el-tooltip placement="top" effect="light">
                        <template #content>
                          Bulk delete charging sites, chargers, and ports
                          <br>
                          Click button to add customer and created at for bulk delete
                        </template>
                        <el-button
                            v-if="
                              $store.state.auth.user != null &&
                              !$store.state.auth.user.is_auditor
                            "
                          @click.stop="CopyCreateAt(scope.row.created_at, scope.row.customer_id)"
                          size="small"
                          class="height-25 rounded-2 m-0 ml-2"
                          color="#DDF0AC"
                          style="width: 25px; height: 25px; padding: 0px; align-items: center;"
                        >
                            <svg style="width: 24px; height: 24px;">
                                <use href="@/assets/svg/newSvgIcon.svg#tableOperationDelete"></use>
                            </svg>
                        </el-button>
                      </el-tooltip>
                    </template>
                  </el-table-column>
                  <el-table-column
          v-else
          fixed="right"
          :label="'Operations'"
          :prop="'operations'"
          align="center"
          width="250"
        >
          <template #default="scope">
                      <el-tooltip placement="top" effect="light">
                        <template #content>
                          Bulk delete charging sites, chargers, and ports
                          <br>
                          Click button to add customer and created at for bulk delete
                        </template>
                        <el-button
                            v-if="
                              $store.state.auth.user != null &&
                              !$store.state.auth.user.is_auditor
                            "
                          @click.stop="CopyCreateAt(scope.row.created_at, scope.row.customer_id)"
                          size="small"
                          class="height-25 rounded-2 m-0 ml-2"
                          color="#DDF0AC"
                          style="width: 25px; height: 25px; padding: 0px; align-items: center;"
                        >
                            <svg style="width: 24px; height: 24px;">
                                <use href="@/assets/svg/newSvgIcon.svg#tableOperationDelete"></use>
                            </svg>
                        </el-button>
                      </el-tooltip>

          </template>
        </el-table-column>
                </el-table>
                </div>

                <!-- Charger Ports -->
                <div class="custom-table-design" v-else-if="chargerFilter == 4">
                <el-table
                  stripe
                  :data="portDataList"
                  :fit="true" 
                  height="300"
                  class="my-2 data-table"
                  scrollbar-always-on: false
                >
                  <el-table-column
                    :label="'Created At'"
                    :prop="'created_at'"
                    :width="$vuetify.display.width <=750 ? 250 : ''"
                    sortable
                    v-if="
                      $store.state.auth.user != null &&
                      $store.state.auth.user.is_admin
                    "
                  >
                    <template #default="scope">
                      {{ scope.row.created_at.replace('T', ' ') }}
                    </template>
                  </el-table-column>
                  <el-table-column
                    :label="'Number of Ports'"
                    :prop="'num_port'"
                    :width="$vuetify.display.width <= 750 ? 150 : ''"
                    sortable
                  />
                  <el-table-column
          v-if="$vuetify.display.width < 750"
          :label="'Operations'"
          :prop="'operations'"
          align="center"
          width="150"
        >
          <template #default="scope">
                      <el-tooltip placement="top" effect="light">
                        <template #content>
                          Bulk delete charging sites, chargers, and ports
                          <br>
                          Click button to add customer and created at for bulk delete
                        </template>
                        <el-button
                            v-if="
                              $store.state.auth.user != null &&
                              !$store.state.auth.user.is_auditor
                            "
                          @click.stop="CopyCreateAt(scope.row.created_at, scope.row.customer_id)"
                          size="small"
                          class="height-25 rounded-2 m-0 ml-2"
                          color="#DDF0AC"
                          style="width: 25px; height: 25px; padding: 0px; align-items: center;"
                        >
                            <svg style="width: 24px; height: 24px;">
                                <use href="@/assets/svg/newSvgIcon.svg#tableOperationDelete"></use>
                            </svg>
                        </el-button>
                      </el-tooltip>
                    </template>
                  </el-table-column>
                  <el-table-column
          v-else
          fixed="right"
          :label="'Operations'"
          :prop="'operations'"
          align="center"
          width="250"
        >
          <template #default="scope">
                      <el-tooltip placement="top" effect="light">
                        <template #content>
                          Bulk delete charging sites, chargers, and ports
                          <br>
                          Click button to add customer and created at for bulk delete
                        </template>
                        <el-button
                            v-if="
                              $store.state.auth.user != null &&
                              !$store.state.auth.user.is_auditor
                            "
                          @click.stop="CopyCreateAt(scope.row.created_at, scope.row.customer_id)"
                          size="small"
                          class="height-25 rounded-2 m-0 ml-2"
                          color="#DDF0AC"
                          style="width: 25px; height: 25px; padding: 0px; align-items: center;"
                        >
                            <svg style="width: 24px; height: 24px;">
                                <use href="@/assets/svg/newSvgIcon.svg#tableOperationDelete"></use>
                            </svg>
                        </el-button>
                      </el-tooltip>

          </template>
        </el-table-column>
                </el-table>
                </div>

            </div>
          </el-col>
        </div>
      </div>
    </el-col>
  </el-row>
</template>

<script>
import UserService from "../../services/user.service";
import { convertToTitleCase, shorterLabel } from "../dashboard/common/common-tools";


export default {
  props: {
    customerIdProp: {
      type: Number,
      default: null,
    },
    dateTimeProp: {
      type: String,
      default: null,
    },
  },
  components: {},
  data() {
    return {
      siteDataList: [],
      chargerDataList: [],
      portDataList: [],

      search: "",

      loading: false,
      chargerFilter: 1,

      filter: {
        customer_id: null,
        start_date: null,
        end_date: null,
        search: "",
        state: "",
      },

      selectedSearchBy: 'site_name',
      selectedTableTab: 'all',
      deleteOption: "all",
      
    };
  },
  watch: {
    // update selected table tab when chargerFilter changed
    chargerFilter: {
      handler: function (newVal) {
        this.selectedSearchBy = 'site_name'; // reset search by when tab change
        this.setSelectTableTab(newVal);
      }
    },

    customerIdProp: {
      handler: function (newVal) {
        if (newVal != null && newVal != undefined && newVal != '') {
          this.fetchDistinctCreatedAtList(newVal);
        }
      },
      deep: true,
    },

  },
  mounted() {

  },
  methods: {

    convertShorterLabel(label, setLength, setMinLength, addOnLabel="") {
      return shorterLabel(label, setLength, setMinLength, addOnLabel);
    },

    convertLabel(str) {
      return convertToTitleCase(str);
    },

    // set select table tabs labels with selected from radio box 1, 2, 3, 4,
    setSelectTableTab(val){
      switch (val) {
        case '1':
          this.selectedTableTab = 'all'
          this.deleteOption = "all";
          break;
        case '2':
          this.selectedTableTab = 'charging_sites'
          this.deleteOption = "site";
          break;
        case '3':
          this.selectedTableTab = 'chargers'
          this.deleteOption = "charger";
          break;
        case '4':
          this.selectedTableTab = 'ports'
          this.deleteOption = "port";
          break;
        default:
          break;
      }
    },

    CopyCreateAt(created_at, customer_id) {
      console.log('created_at', created_at);
      console.log('customer_id', customer_id);
      this.$emit("tableAction", {
        created_at: created_at,
        customer_id: customer_id,
        option: this.deleteOption,
        kind: "copyCreateAt",
      });
    },

    // fetch distinct created_at list
    async fetchDistinctCreatedAtList(customer_id) {
      try {
        console.log('customer_id', customer_id);
        if (customer_id == null || customer_id == undefined || customer_id == '') {
          console.log("invalid customer id");
          this.portDataList = [];
          this.chargerDataList = [];
          this.siteDataList = [];
          return;
        }
        const response = await UserService.getDistinctCreatedAtList(customer_id);
        if (!response || !response.data) {
          this.portDataList = [];
          this.chargerDataList = [];
          this.siteDataList = [];
          return;
        }

        this.portDataList = response.data.data.port_result;
        this.chargerDataList = response.data.data.charger_result;
        this.siteDataList = response.data.data.site_result;

      } catch (error) {
        console.log('error', error);
        if (error.response.status == 401 || error.response.status == 403) {
          this.$router.push({
            path: "/",
          });
        }
      }
    },
  },
};
</script>

